import { render, staticRenderFns } from "./ManageWebsite.vue?vue&type=template&id=22d95b42&scoped=true&"
import script from "./ManageWebsite.vue?vue&type=script&lang=js&"
export * from "./ManageWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d95b42",
  null
  
)

export default component.exports